import { render, staticRenderFns } from "./ship_receiveLink_dialog.vue?vue&type=template&id=f6e47130"
import script from "./ship_receiveLink_dialog.vue?vue&type=script&lang=js"
export * from "./ship_receiveLink_dialog.vue?vue&type=script&lang=js"
import style0 from "./ship_receiveLink_dialog.vue?vue&type=style&index=0&id=f6e47130&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports